import React from 'react';
import { Modal, Box, Typography, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ButtonTheme from '../ThemeButton/ThemeButton';

const ModalBoxV2 = ({
  open,
  onClose,
  title,
  body,
  primaryAction,
  primaryActionText,
  secondaryActionText,
  isPrimaryDisabled,
  secondaryAction,
  isSecondaryDisabled,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: '430px',
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 4,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Box
          sx={{
            borderBottom: '1px solid #ccc',
            pb: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ py: 2 }}>
          <Typography variant="body1">{body}</Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 2,
          }}
        >
          <ButtonTheme
            disabled={isSecondaryDisabled}
            className="mx-3"
            color="primary"
            onClick={secondaryAction}
          >
            {secondaryActionText}
          </ButtonTheme>

          <ButtonTheme
            disabled={isPrimaryDisabled}
            color="dark"
            variant="contained"
            onClick={primaryAction}
          >
            {primaryActionText}
          </ButtonTheme>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalBoxV2;
